import React from "react";
import Heading from "../Heading";
import { HomeBannerStyles } from "../Styles";
import GlobalSubHeading from "../GlobalSubHeading";
import { getMeaning } from "../../utils/localization";
import { Box, Grid, Paper, Typography } from "@mui/material";
import BlogHeroCardFour from "../BlogHero/BlogHeroCardFour";

const BlogDetailsFour = () => {
  return (
    <Box>
      <Box>
        <BlogHeroCardFour />
      </Box>

      <Box maxWidth="xlg" sx={styles.SubContainer}>
        <Box sx={{ mx: { xs: 3, md: 12 } }}>
          <Box align="center">
            <Heading title={getMeaning("BLGDTLSTHREE.HDNG")} />
          </Box>

          <GlobalSubHeading
            subTitle={getMeaning("BLGDTLSTHREE.DSCRPTN")}
            ParentContainer={{}}
            textSx={{
              textAlign: "justify",
              width: { xs: "100%", sm: "100%", md: "100%" },
            }}
          />
        </Box>

        <Grid sx={styles.MiddleGridContainer}>
          <Grid sx={{ mx: { xs: 0, md: 8 } }} item xs={12} md={7}>
            <Typography variant="body1" sx={styles.Headingtxt}>
              <strong>{getMeaning("BLGDTLSTHREE.LCLFNDTNHDNG")}:</strong>
            </Typography>
            <Typography variant="body1" mb={2} sx={styles.DescriptionTxt}>
              {getMeaning("BLGDTLSTHREE.LCLFNDTNDSCRPTN")}
            </Typography>

            <Typography variant="body1" sx={styles.Headingtxt}>
              <strong>{getMeaning("BLGDTLSTHREE.GLBLRCHHDNG")}</strong>
            </Typography>
            <Typography variant="body1" mb={1} sx={styles.DescriptionTxt}>
              {getMeaning("BLGDTLSTHREE.GLBLRCHDSCRPTN1")}
            </Typography>
            <Typography variant="body1" mb={2} sx={styles.DescriptionTxt}>
              {getMeaning("BLGDTLSTHREE.GLBLRCHDSCRPTN2")}
            </Typography>

            <Typography variant="boy1" sx={styles.Headingtxt}>
              <strong>{getMeaning("BLGDTLSTHREE.HLSTCASTNCEHDNG")}:</strong>
            </Typography>
            <Typography variant="body1" mb={3} sx={styles.DescriptionTxt}>
              {getMeaning("BLGDTLSTHREE.HLSTCASTNCEDSCRPTN")}
            </Typography>

            <Paper elevation={2} sx={styles.PaperContainer}>
              <Typography variant="body1" sx={styles.PaperItalicTxt}>
                {getMeaning("BLGDTLSTHREE.ITLCCARDLBL")}
              </Typography>
            </Paper>

            <Typography variant="body" sx={styles.Headingtxt}>
              <strong>{getMeaning("BLGDTLSTHREE.THOUGHTLDRSHPHDNG")} </strong>
            </Typography>
            <Typography
              variant="body1"
              sx={[
                HomeBannerStyles.BannerDescriptionTwo,
                { fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" } },
              ]}
            >
              {getMeaning("BLGDTLSTHREE.THOUGHTLDRSHPDSCRPTN")}
            </Typography>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box
              component="img"
              src={require("../../assets/images/Blog/BlogCoverImg.jpg")}
              alt="VAS in Insurance"
              sx={styles.BlogsImgView}
            />
          </Grid>
        </Grid>

        <Box mt={2} sx={{ mx: { xs: 3, sm: 3, md: 12 } }} mb={0} align="left">
          <Typography variant="body" sx={styles.Headingtxt}>
            <strong>{getMeaning("BLGDTLSTHREE.CNCLSNHDNG")} </strong>
          </Typography>
          <Typography
            variant="body1"
            sx={[
              HomeBannerStyles.BannerDescriptionTwo,
              { fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" } },
            ]}
          >
            {getMeaning("BLGDTLSTHREE.CNCLSNDSCRPTN")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BlogDetailsFour;

const styles = {
  SubContainer: { py: 5, background: "#fff", width: "100%" },
  MiddleGridContainer: {
    mx: { xs: 2, md: 4 },
    display: { md: "flex" },
    alignItems: { md: "center" },
    justifyContent: { md: "center" },
  },
  PaperContainer: {
    backgroundColor: "#f8fbff",
    borderLeft: "5px solid #1976d2",
    px: 3,
    py: 3,
    mb: 3,
  },
  PaperItalicTxt: {
    fontStyle: "italic",
    fontFamily: '"Poppins",serif',
    fontWeight: 400,
    textAlign: "justify",
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
  },
  Headingtxt: {
    mt: 2,
    fontFamily: '"Poppins",serif',
    fontWeight: 400,
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
  },
  DescriptionTxt: {
    fontFamily: '"Poppins",serif',
    fontWeight: 400,
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
  },
  BlogsImgView: {
    width: "100%",
    height: "auto",
    borderRadius: 2,
    boxShadow: 2,
  },
};
